import {
  Component,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ActivatedRoute,
  RouterLink
} from '@angular/router';
import { Router } from '@angular/router';
import {
  HttpClient
} from '@angular/common/http';

@Component({
  selector: 'app-product-showcase',

  standalone: true,

  imports: [
    CommonModule,
    RouterLink
  ],

  templateUrl: './product-showcase.html',

  styleUrls: ['./product-showcase.scss']
})
export class ProductShowcase implements OnInit {

  apiUrl = 'https://lazzaro-api1.onrender.com';

  product: any;

  selectedImage = '';

  loading = true;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) { }

  ngOnInit(): void {

    const slug = this.route.snapshot.paramMap.get('slug');

    if (slug) {
      this.loadProduct(slug);
    }

  }
goToContact() {
    this.router.navigate(['/contact']);
}
  loadProduct(slug: string): void {

    this.loading = true;

    this.http.get<any>(
      `${this.apiUrl}/api/products/${slug}`
    )
    .subscribe({

      next: (res) => {

        console.log(res);

        this.product = res;
        
        if (res.images && res.images.length > 0) {
          this.selectedImage = res.images[0].imageUrl;
        } else {
          this.selectedImage = res.mainImage;
        }

        this.loading = false;

        this.cdr.detectChanges();

      },

      error: (err) => {

        console.error(err);

        this.loading = false;

        this.cdr.detectChanges();

      }

    });

  }

  selectImage(image: string): void {

    this.selectedImage = image;

  }

}